export enum QuoteMigrationStatuses {
  IN_PROGRESS = 'inprogress',
  COMPLETED = 'completed',
  FAILED = 'failed',
}
